class ProductGallery extends HTMLElement {
    constructor() {
        super(), this.init();
        new ResizeObserver((t) => {
            document.querySelector(".product-gallery__image--active").scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }), this.update();
        }).observe(this),
            this.navItems.forEach((t) => t.addEventListener("click", this.onNavItemClick.bind(this))),
            this.prevButton.forEach((t) => {
                t.addEventListener("click", this.onButtonClick.bind(this));
            }),
            this.nextButton.forEach((t) => {
                t.addEventListener("click", this.onButtonClick.bind(this));
            }),
            window.addEventListener("message", this.onMessage.bind(this)),
            window.addEventListener("resize", this.onResize.bind(this));
    }
    init() {
        (this.imagesContainer = this.querySelector(".product-gallery__images")),
            (this.navItems = this.querySelectorAll(".product-gallery__nav-item")),
            (this.dots = this.querySelectorAll(".product-gallery__nav-item.dot-nav")),
            (this.images = this.querySelectorAll(".product-gallery__image")),
            (this.filteredImages = this.querySelectorAll(".product-gallery__image.filtered")),
            (this.filteredDots = this.querySelectorAll(".product-gallery__nav-item.dot-nav.filtered")),
            (this.prevButton = this.querySelectorAll('button[name="previous"]')),
            (this.nextButton = this.querySelectorAll('button[name="next"]')),
            (this.arrowContainer = this.querySelector(".carousel-arrow-container")),
            (this.onlyDefaultVariant = this.dataset.onlyDefaultVariant),
            -1 === this.findCurrentIndex() || "true" === this.onlyDefaultVariant
                ? (this.setCurrentImage(this.images[0]), this.setCurrentDot(this.dots[0]))
                : (this.setSlideCount(this.findCurrentIndex() + 1), this.setCurrentDot(this.dots[this.findCurrentIndex()])),
            window.innerWidth < 750 ? (this.imagesContainer.style.maxHeight = "none") : (this.imagesContainer.style.maxHeight = this.querySelector(".product-gallery__image--active img").height + "px"),
            this.arrowContainer && (this.arrowContainer.style.top = this.querySelector(".product-gallery__image--active img").height / 2 + "px");
    }
    onMessage(t) {
        if (t.data && ("variant_changed" !== t.data.type || "filter" != t.data.action)) {
            if ("variant_changed" == t.data.type) {
                let e = Array.from(this.images).find((e) => e.dataset.mediaId == t.data.variant.featured_media.id);
                e && this.setCurrentImage(e), this.setCurrentDot(this.dots[Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active"))]);
            }
            "product_gallery" == t.data.type &&
                "filter" == t.data.action &&
                ((this.filteredImages = this.querySelectorAll(".product-gallery__image.filtered")),
                (this.filteredDots = this.querySelectorAll(".product-gallery__nav-item.dot-nav.filtered")),
                this.setCurrentImage(this.filteredImages[0]),
                this.setCurrentDot(this.filteredDots[0])),
                "product_gallery" == t.data.type &&
                    "unfilter" == t.data.action &&
                    (this.setSlideCount(Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active")) + 1),
                    this.setCurrentDot(this.dots[Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active"))]));
        }
    }
    onResize(t) {
        window.innerWidth < 750 ? (this.imagesContainer.style.maxHeight = "none") : (this.imagesContainer.style.maxHeight = this.querySelector(".product-gallery__image--active img").height + "px"),
            this.arrowContainer && (this.arrowContainer.style.top = this.querySelector(".product-gallery__image--active img").height / 2 + "px");
    }
    onVariantChange(t) {
        if (!t.data || "variant_changed" !== t.data.type) return;
        const e = Array.from(this.images).find((e) => e.dataset.mediaId == t.data.variant.featured_media.id);
        e && this.setCurrentImage(e), this.setSlideCount(Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active")) + 1);
    }
    onNavItemClick(t) {
        window.postMessage({ type: "product_gallery", action: "nav_click" }, "*");
        const e = t.target.closest("li").dataset.mediaId,
            i = t.target.closest("li.dot-nav");
        this.setCurrentDot(i),
            this.images.forEach((t) => t.classList.remove("product-gallery__image--active")),
            this.setCurrentImage(Array.from(this.images).find((t) => t.dataset.mediaId === e)),
            this.querySelectorAll(".product-gallery__image.filtered").length > 0
                ? this.setSlideCount(Array.from(this.filteredImages).findIndex((t) => t.classList.contains("product-gallery__image--active")) + 1)
                : this.setSlideCount(Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active")) + 1);
    }
    update() {
        window.postMessage({ type: "product_gallery", action: "update" }, "*"),
            this.prevButton.forEach((t) => {
                t.removeAttribute("disabled");
            }),
            this.nextButton.forEach((t) => {
                t.removeAttribute("disabled");
            });
    }
    setCurrentImage(t) {
        window.postMessage({ type: "product_gallery", action: "set_image", media_id: t.dataset.mediaId }, "*"),
            this.images.forEach((t) => t.classList.remove("product-gallery__image--active")),
            t.classList.add("product-gallery__image--active"),
            t.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }),
            this.update();
    }
    setCurrentDot(t) {
        window.postMessage({ type: "product_gallery", action: "set_dot" }, "*"),
            this.dots.length > 0 && (this.dots.forEach((t) => t.classList.remove("product-gallery__nav-item--active")), t.classList.add("product-gallery__nav-item--active"), this.update());
    }
    setSlideCount(t) {
        window.postMessage({ type: "product_gallery", action: "set_count" }, "*"), document.getElementById("sliderCount") && (document.getElementById("sliderCountCurrent").textContent = t);
    }
    findCurrentIndex() {
        return $(".product-gallery__images .filtered").length > 0
            ? Array.from(this.filteredImages).findIndex((t) => t.classList.contains("product-gallery__image--active"))
            : Array.from(this.images).findIndex((t) => t.classList.contains("product-gallery__image--active"));
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = this.findCurrentIndex(),
            i = this.images.length - 1;
        $(".product-gallery__images .filtered").length > 0 && ((i = $(".product-gallery__images #sliderCount").attr("data-slides") - 1), (i = $(".product-gallery__images .filtered").length - 1)),
            "next" === t.currentTarget.name ? (e == i ? (e = 0) : e++) : 0 == e ? (e = i) : e--,
            this.setSlideCount(e + 1),
            $(".product-gallery__images .filtered").length > 0 ? (this.setCurrentImage(this.filteredImages[e]), this.setCurrentDot(this.filteredDots[e])) : (this.setCurrentImage(this.images[e]), this.setCurrentDot(this.dots[e]));
    }
}
var waitForJQueryProductGallery = setInterval(function () {
    if (typeof $ != 'undefined' && typeof $().slick != 'undefined') {  
      customElements.define("product-gallery", ProductGallery);
      clearInterval(waitForJQueryProductGallery);
    }
}, 10);

